/* ==========================================================================
   SERPROMAQ - ANIMACIÓN DE CONTADORES DE MÉTRICAS Y REVELADO DE SCROLL
   ========================================================================== */

export function initCountersAndAnimations() {
  // 1. Intersection Observer for Scroll Reveal
  const revealElements = document.querySelectorAll('.reveal-on-scroll');

  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15
  });

  revealElements.forEach(el => revealObserver.observe(el));

  // 2. Metric Counters Animation
  const counters = document.querySelectorAll('.metric-number[data-target]');

  const counterObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const counter = entry.target;
        const target = parseFloat(counter.getAttribute('data-target'));
        const prefix = counter.getAttribute('data-prefix') || '';
        const suffix = counter.getAttribute('data-suffix') || '';
        const isDecimal = counter.getAttribute('data-decimal') === 'true';

        let count = 0;
        const duration = 2000; // 2 seconds
        const stepTime = 30;
        const steps = duration / stepTime;
        const increment = target / steps;

        const timer = setInterval(() => {
          count += increment;
          if (count >= target) {
            count = target;
            clearInterval(timer);
          }

          const formattedNumber = isDecimal 
            ? count.toFixed(1) 
            : Math.floor(count).toLocaleString();

          counter.textContent = `${prefix}${formattedNumber}${suffix}`;
        }, stepTime);

        observer.unobserve(counter);
      }
    });
  }, {
    threshold: 0.5
  });

  counters.forEach(counter => counterObserver.observe(counter));
}
